import { Box, Divider, List } from "@chakra-ui/react"
import React, { useEffect, useRef } from "react"
import { useInViewport } from "react-in-viewport"
import { ExtendedZoneGroupFragment } from "../../graphql"
import { ZoneGroupListItem } from "./ZoneGroupListItem"

export type ZoneGroupsListProps = {
	zoneGroups: ExtendedZoneGroupFragment[]
	loadMore: () => void
}

export const ZoneGroupsList: React.FC<ZoneGroupsListProps> = ({ zoneGroups, loadMore }) => {
	const ref = useRef()

	const { inViewport } = useInViewport(ref as any, { threshold: 0.25 })

	useEffect(() => {
		if (inViewport) {
			loadMore()
		}
	}, [inViewport, loadMore])

	return (
		<List spacing={2}>
			{zoneGroups.map((zoneGroup) => (
				<>
					<ZoneGroupListItem key={zoneGroup._id} zoneGroup={zoneGroup} />
					<Divider />
				</>
			))}
			<Box w="full" h="2" ref={ref as any} />
		</List>
	)
}
